import ReactGA from 'react-ga'

export const enviaEventoGA = ( category, action ) => {
  const eventOptions = {
    action,
    category
  }
  ReactGA.event( eventOptions )
}

export const acionaPageView = () => {
  const url = `${window.location.pathname}${window.location.search}${window.location.hash}`
  ReactGA.pageview( url )
}
